import React from 'react';
import { X, MessageCircle, Mail, Phone, Sparkles } from 'lucide-react';

const SUBJECT_OPTIONS = [
  'General enquiry',
  'Order status',
  'Returns & exchanges',
  'Product question',
  'Wholesale / bulk order',
  'Something else',
];

const ContactModal = ({ open, onClose, formData, onChange, errors, onSubmit, isSubmitting }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[75] flex items-center justify-center p-4 sm:p-8">
      <div className="absolute inset-0 bg-ink/60 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-surface w-full max-w-4xl max-h-[90vh] overflow-y-auto rounded-md shadow-2xl" data-lenis-prevent>
        <div className="flex items-center justify-between px-6 sm:px-8 py-5 border-b border-line sticky top-0 bg-surface">
          <h2 className="font-display text-2xl text-ink">Get in touch</h2>
          <button onClick={onClose} className="p-3 hover:bg-paper rounded-full transition-colors" aria-label="Close">
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-5">
          <div className="md:col-span-2 p-6 sm:p-8 bg-paper space-y-3">
            <a href="https://wa.me/254111566826" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 bg-surface border border-line rounded-md p-4 hover:border-accent transition-colors">
              <MessageCircle className="w-5 h-5 text-accent" />
              <div>
                <p className="text-sm font-medium text-ink">WhatsApp</p>
                <p className="text-xs text-ink-faint">Usually replies in minutes</p>
              </div>
            </a>
            <a href="mailto:info@digitalpulseke.com" className="flex items-center gap-3 bg-surface border border-line rounded-md p-4 hover:border-accent transition-colors">
              <Mail className="w-5 h-5 text-accent" />
              <div>
                <p className="text-sm font-medium text-ink">Email</p>
                <p className="text-xs text-ink-faint">info@digitalpulseke.com</p>
              </div>
            </a>
            <a href="tel:+254111566826" className="flex items-center gap-3 bg-surface border border-line rounded-md p-4 hover:border-accent transition-colors">
              <Phone className="w-5 h-5 text-accent" />
              <div>
                <p className="text-sm font-medium text-ink">Phone</p>
                <p className="text-xs text-ink-faint">+254 111 566 826</p>
              </div>
            </a>
            <div className="bg-ink rounded-md p-4 mt-6">
              <Sparkles className="w-5 h-5 text-brass-deep mb-2" />
              <p className="text-paper text-sm font-medium mb-1">15% off your first order</p>
              <p className="text-paper/60 text-xs">Message us and we'll send a code.</p>
            </div>
          </div>

          <form onSubmit={onSubmit} className="md:col-span-3 p-6 sm:p-8 space-y-4">
            <div>
              <label className="dpc-label text-ink-faint block mb-1.5">Name</label>
              <input
                type="text"
                value={formData.name}
                onChange={(e) => onChange('name', e.target.value)}
                className="w-full border border-ink-faint rounded-sm px-3.5 py-2.5 text-sm bg-surface focus:ring-1 focus:ring-accent focus:border-accent"
              />
              {errors.name && <p className="text-xs text-accent mt-1">{errors.name}</p>}
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label className="dpc-label text-ink-faint block mb-1.5">Email</label>
                <input
                  type="email"
                  value={formData.email}
                  onChange={(e) => onChange('email', e.target.value)}
                  className="w-full border border-ink-faint rounded-sm px-3.5 py-2.5 text-sm bg-surface focus:ring-1 focus:ring-accent focus:border-accent"
                />
                {errors.email && <p className="text-xs text-accent mt-1">{errors.email}</p>}
              </div>
              <div>
                <label className="dpc-label text-ink-faint block mb-1.5">Phone (optional)</label>
                <input
                  type="tel"
                  value={formData.phone}
                  onChange={(e) => onChange('phone', e.target.value)}
                  className="w-full border border-ink-faint rounded-sm px-3.5 py-2.5 text-sm bg-surface focus:ring-1 focus:ring-accent focus:border-accent"
                />
              </div>
            </div>
            <div>
              <label className="dpc-label text-ink-faint block mb-1.5">Subject</label>
              <select
                value={formData.subject}
                onChange={(e) => onChange('subject', e.target.value)}
                className="w-full border border-ink-faint rounded-sm px-3.5 py-2.5 text-sm bg-surface focus:ring-1 focus:ring-accent focus:border-accent"
              >
                <option value="">Select a subject</option>
                {SUBJECT_OPTIONS.map((s) => <option key={s} value={s}>{s}</option>)}
              </select>
              {errors.subject && <p className="text-xs text-accent mt-1">{errors.subject}</p>}
            </div>
            <div>
              <label className="dpc-label text-ink-faint block mb-1.5">Message</label>
              <textarea
                rows={4}
                value={formData.message}
                onChange={(e) => onChange('message', e.target.value)}
                className="w-full border border-ink-faint rounded-sm px-3.5 py-2.5 text-sm bg-surface focus:ring-1 focus:ring-accent focus:border-accent resize-none"
              />
              {errors.message && <p className="text-xs text-accent mt-1">{errors.message}</p>}
            </div>
            <button
              type="submit"
              disabled={isSubmitting}
              className="w-full bg-ink text-paper dpc-label py-3.5 rounded-full hover:bg-accent transition-colors disabled:opacity-50"
            >
              {isSubmitting ? 'Sending…' : 'Send message'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactModal;
